import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BookingPrice,
  BookingSubStatusEnum,
  FlightRecord,
  TravelerRecord,
} from '@pulpo/pulpo-models';

@Component({
  selector: 'booking-record-flight',
  templateUrl: './booking-record-flight.component.html',
  styleUrls: ['./booking-record-flight.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BookingRecordFlightComponent {
  @Input() flightRecord: FlightRecord;
  @Input() travelerRecord: TravelerRecord;
  @Input() bookingPrice: BookingPrice;
  @Input() creationDate: Date;
  BookingSubStatusEnum = BookingSubStatusEnum;
  Number = Number;

  /** Bagage acheté en passant sur un tarif brandé : offer.isLuggageIncluded vaut true mais le bagage est payé. */
  get isBrandedUpsell(): boolean {
    return this.flightRecord?.luggageMode === 'BRANDED_UPSELL';
  }

  /** Bagage inclus dans le tarif d'origine, hors tarif brandé. */
  get isLuggageIncludedInOffer(): boolean {
    return (
      this.flightRecord?.offer?.isLuggageIncluded === true &&
      !this.isBrandedUpsell
    );
  }

  get brandedFareName(): string {
    return this.flightRecord?.bags?.find((bg) => bg.metadata)?.metadata || '';
  }

  get luggageSummary() {
    if (this.isLuggageIncludedInOffer) {
      return 'inclus';
    }
    if (this.flightRecord.bags && this.flightRecord.bags.length > 0) {
      let luggageSummary = '';
      this.flightRecord.bags.forEach((bg) => {
        const quantity = bg.quantity ? bg.quantity : '1';
        const weight = bg.weight || '23';
        if (this.isBrandedUpsell && bg.metadata) {
          luggageSummary += `${quantity} x ${weight} kg — tarif ${bg.metadata}. `;
        } else {
          luggageSummary += quantity + ' x ' + weight + ' kg. ';
        }
      });
      return luggageSummary;
    } else {
      return '';
    }
  }

  getFlightPrice(withLuggage: boolean) {
    let price = this.bookingPrice.referenceFlightPrice
      ? Number(this.bookingPrice.referenceFlightPrice)
      : 0;
    if (this.bookingPrice.flightPrice && this.bookingPrice.flightPrice > 0) {
      price += Number(this.bookingPrice.flightPrice);
    }

    if (withLuggage && this.getTotalLuggage() > 0) {
      price += Number(this.bookingPrice.luggagePrice);
    }

    return price.toFixed(2);
  }

  /**
   * Calcule le nombre total de bagages demandés pour le vol
   * @returns Le nombre total de bagages, 0 si aucun
   */
  getTotalLuggage(): number {
    const requestedLuggage = this.flightRecord?.requestedLuggage;

    if (!requestedLuggage || requestedLuggage.length === 0) {
      return 0;
    }

    return requestedLuggage.reduce(
      (total, reqBag) => total + (reqBag.quantity ?? 0),
      0
    );
  }

  getWeight(bagKey: string): string {
    if (!bagKey) return '23';
    return bagKey.split('KG')[0]?.replace(/\D/g, '') || '23';
  }

  getTotalPrice() {
    if (this.bookingPrice?.paidFlightPrice) {
      return this.bookingPrice.paidFlightPrice;
    }
    if (this.bookingPrice?.referenceFlightPrice) {
      let price = this.bookingPrice.referenceFlightPrice
        ? Number(this.bookingPrice.referenceFlightPrice)
        : 0;
      if (this.bookingPrice.flightPrice) {
        price += Number(this.bookingPrice.flightPrice);
      }
      if (this.bookingPrice.luggagePrice) {
        price += Number(this.bookingPrice.luggagePrice);
      }
      return price.toFixed(2);
    }
    return 'N/A';
  }
}
